import eventBus from '../../utils/emitter-event-bus';
import { NarratorEventBus } from '../narrator/narrator.model';
import { applyEffect } from './inventory-effect-handler';
import { InventoryRepository } from './inventory-repository';
import { InventoryEffect, InventoryEventBus, InventoryReader, InventoryState } from './inventory.model';

export class Inventory implements InventoryReader {
  private static instance: Inventory | undefined;
  private state: InventoryState;

  private constructor(private readonly repository: InventoryRepository) {
    this.state = repository.load();
    eventBus.on(NarratorEventBus.nodeEntered, (payload) => this.onNodeEntered(payload.effects));
  }

  static init(repository: InventoryRepository): Inventory {
    if (!Inventory.instance) {
      Inventory.instance = new Inventory(repository);
    }
    return Inventory.instance;
  }

  static getInstance(): Inventory {
    if (!Inventory.instance) {
      throw new Error('Inventory.init(repository) must be called before getInstance().');
    }
    return Inventory.instance;
  }

  getState(): Readonly<InventoryState> {
    return this.state;
  }

  private onNodeEntered(effects: InventoryEffect[]): void {
    let next = this.state;
    for (const effect of effects) {
      next = applyEffect(next, effect);
    }
    if (next === this.state) return;
    this.state = next;
    this.repository.save(this.state);
    eventBus.emit(InventoryEventBus.changed);
  }
}
